module.exports = __webpack_public_path__ + "static/media/doc.2c7abb75.svg";